const StatsSection = ({ language }) => {
    const fr = language === 'fr';

    const stats = [
        {
            value: '+20K',
            labelFr: 'Plus de 20 000 élèves pilotes accompagnés depuis 2014',
            labelEn: '20,000+ student pilots supported since 2014',
        },
        {
            value: '+10',
            labelFr: 'Plus de 10 ans d’expérience',
            labelEn: '10+ years of experience',
        },
        {
            value: '15K',
            labelFr: 'Une base de plus de 15 000 questions expliquées',
            labelEn: '15,000+ questions and explanations',
        },
        {
            value: '100 %',
            labelFr: '100 % canadien & entièrement bilingue',
            labelEn: '100% Canadian and fully bilingual',
        },
    ];

    return (
        <section className="relative bg-white dark:bg-[#0f0f0f] text-gray-900 dark:text-white py-20 md:py-28">
            <div className="max-w-[1151px] mx-auto px-6 text-center">
                {/* Kicker */}
                <p className="font-['Rethink_Sans',sans-serif] font-bold text-[14px] tracking-[3.5px] text-[#71a7ff] leading-[34px]">
                    {fr ? 'CHIFFRES CLÉS' : 'KEY FIGURES'}
                </p>

                {/* Title */}
                <h2 className="font-['Rethink_Sans',sans-serif] font-normal text-gray-900 dark:text-white text-[40px] leading-[40px] tracking-[-1px] md:text-[50px] md:leading-[46px] md:tracking-[-1.5px] mt-3 md:mt-4 mb-12 md:mb-16">
                    {fr ? 'Notre expertise' : 'Our track record'}
                </h2>

                {/* Stats grid — 2 cols mobile, 4 cols desktop */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
                    {stats.map((stat, i) => (
                        <div key={i} className="flex flex-col items-center text-center">
                            <p className="font-['Rethink_Sans',sans-serif] font-bold text-[#0061fe] text-[42px] md:text-[56px] leading-[1] tracking-[-2px] mb-3">
                                {stat.value}
                            </p>
                            <p className="font-['Rethink_Sans',sans-serif] font-normal text-gray-600 dark:text-[#a9b1bd] text-[14px] md:text-[15px] leading-[20px] max-w-[180px]">
                                {fr ? stat.labelFr : stat.labelEn}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StatsSection;
